import { axiosFetch } from "../../utils/AxiosFetch";
import { deleteCommentsConstant } from "../constants";
import { SnackbarActions } from './snackbar.actions'
export const deleteComment = (id) => (dispatch) => {
    axiosFetch({
        method: "delete",
        url: `/OKRs/okr/comment/${id}`
    })

        .then((res) => {
            if (res.status === 200) {
                dispatch(deleteComment_Succeed(res))
            }
            if (res.status === 400) {
                dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
            }
            else if (res.status === 401) {
                window.location.href = '/';
            }
        })

        .catch(err => {
            dispatch(deleteComment_Failed(err));
        })

    function deleteComment_Succeed(data) {
        return {
            type: deleteCommentsConstant.DELETE_COMMENT_SUCCESS,
            payload: data
        }
    }

    function deleteComment_Failed(err) {
        return {
            type: deleteCommentsConstant.DELETE_COMMENT_FAILURE,
            payload: err
        }
    }
}